import React from 'react'
import styled from 'styled-components'
import { fontWeight } from 'themes/font'
import breakPoints from 'themes/breakPoints'

const Item = styled.div``

const Question = styled.h4`
  font-size: 20px;
  margin-top: 0;
  margin-bottom: 8px;
  min-height: 47.27px;
  font-weight: ${fontWeight.medium};
  @media (max-width: ${breakPoints.md.max}px) {
    font-size: 1.25rem;
  }
`

const Answer = styled.p`
  font-size: 20px;
  color: #9b9b9b;
  margin-bottom: 0;
  @media (max-width: ${breakPoints.md.max}px) {
    font-size: 1rem;
  }
`

export default ({ className, question, answer }) => (
  <Item className={className}>
    <Question>{question}</Question>
    <Answer>{answer}</Answer>
  </Item>
)
